module.exports = __webpack_public_path__ + "img/login.31e51b8d.jpg";